import {
  BulletList,
  Header,
  PageHeader,
  Paragraph,
  TextInfoPage,
} from "../../components/Page";
import {useTranslation} from "react-i18next";

export default function AboutPage() {
  const { t } = useTranslation();
    
  const P = Paragraph;
  const H = Header;
  const BL = BulletList;

  return (
      <TextInfoPage>
          <PageHeader>
              { t("aboutPage.title") }
          </PageHeader>
          <P>
              { t("aboutPage.text.problem") }
          </P>
          <P>
              { t("aboutPage.text.solution") }
          </P>
          <H>{ t("aboutPage.paragraphs.performanceProModule.header") }</H>
          <P>
              { t("aboutPage.paragraphs.performanceProModule.text") }
          </P>
          <BL>
              <ul>
                  <li>{ t("aboutPage.paragraphs.performanceProModule.featureList.graderStatistics") }</li>
                  <li>{ t("aboutPage.paragraphs.performanceProModule.featureList.productionEggTypes") }</li>
                  <li>{ t("aboutPage.paragraphs.performanceProModule.featureList.productionSuppliers") }</li>
                  <li>{ t("aboutPage.paragraphs.performanceProModule.featureList.graphs") }</li>
              </ul>
          </BL>
          <H>{ t("aboutPage.paragraphs.realtimeDashboardModule.header") }</H>
          <P>
              { t("aboutPage.paragraphs.realtimeDashboardModule.text") }
          </P>
          <H>{ t("aboutPage.paragraphs.benchmarkModule.header") }</H>
          <P>
              { t("aboutPage.paragraphs.benchmarkModule.text") }
          </P>
      </TextInfoPage>
  );
}
